import axiosInstance from 'helpers/axiosInstance';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Domiciliacion from './Domiciliacion';
import { Modal } from 'reactstrap';
import {useDispatch} from "react-redux";
import {cambiaruta,cambiasidebar} from "../../Slicersreducers";
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';
import getConsulta from './Security';

const ConsultaDomiciliacion = (props) => {
    const [consultaDomiciliacion, setConsultaDomiciliacion] = useState(props.consulta);
    const [detalleConsultaDomiciliacion, setDetalleConsultaDomiciliacion] = useState([]);
    const [modificaConsultaDomiciliacion, setModificaConsultaDomiciliacion] = useState([]);
    const [eliminaConsultaDomiciliacion, setEliminaConsultaDomiciliacion] = useState([]);
    const [infoModal, setInfoModal] = useState(false);
    const [cancelationsModal, setCancelationsModal] = useState(false);
    const [successCancelationModal, setSuccessCancelationModal] = useState(false);
    const [confirmElimina, setConfirmElimina] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [listAlert, setListAlert] = useState([]);
    var createReactClass = require("create-react-class");
    const [isdomiexito,setisdomiexito]=useState(props.notificadomi);
    const [itemDelete, setItemDelete] = useState([]);

    const dispatch=useDispatch();

    // useEffect(() => {
    // dispatch(cambiaruta("Inicio/Seguridad/Domiciliación"));
    // dispatch(cambiasidebar(false));
    // }, []);

    const  detalleDomiciliacion = async (item, tipo) =>{
      console.log("consumo de domiciliacion");
      setIsLoading(true);
      const response = await axiosInstance().get("/WSGYG39_2/api/Domiciliation/Domiciliations/"+ item.associationSecuence + "/" + item.operationType + "/" + item.status + "/" + item.associationDescription)
      .catch(err => {
        setIsLoading(false);
        setListAlert([
          {
            description: "No se pudo autorizar la transacción.",
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle"
          }
        ]);
      });
      if (response != "err") {
        console.log("respuesta api", response.data)
        setDetalleConsultaDomiciliacion(response.data);
        if(tipo == "1"){
          setInfoModal(true);
          setIsLoading(false);
        }else{
          dispatch(cambiaruta("Inicio/Seguridad/Domiciliación/Modificación"))
          setIsLoading(false);
          props.cambioTab("modificadomi",response.data);
        }
      }
    }
    const  modificaDomiciliacion = async () =>{
      setIsLoading(true);
      const response = await axiosInstance().put("/WSGYG39_2/api/Domiciliation/UpdateDomiciliation/" , detalleConsultaDomiciliacion)
      .catch(err => {
        return 'err';
      });
      if (response != "err") {
        console.log("respuesta api", response.data)
        setModificaConsultaDomiciliacion(response.data);
        setIsLoading(false);
      }
    }
    const  eliminaDomiciliacion = async (item) =>{
      console.log(item.associationSecuence);
      const response = await axiosInstance().delete("/WSGYG39_2/api/Domiciliation/Domiciliations/" + item.associationSecuence + "/S")
      .catch(err => {
        return 'err';
      });
      if (response != "err") {
        console.log("respuesta api", response.data)
        setEliminaConsultaDomiciliacion(response.data);
        setSuccessCancelationModal(true);
      }

      const request = await axiosInstance().get("/WSGYG39_2/api/Domiciliation/Domiciliations")
      if (request != "err") {
       console.log("respuesta api2",request.data)
       setConsultaDomiciliacion(request.data);
        }
    }
    const ejecutasalir=()=>{
      setCancelationsModal(false);
    }
    // useEffect(() => {
    //     async function getConsulta() {
    //       setIsLoading(true);
    //       const request = await axiosInstance().get("/WSGYG39_2/api/Domiciliation/Domiciliations")
    //         .catch(err => {
    //           setIsLoading(false)
    //           return 'err';
    //         });
    //       if (request != 'err') {
    //         setIsLoading(false);
    //         console.log(request.data);
    //         // console.log(request.data.summaryProduct.product);
    //         setConsultaDomiciliacion(request.data);
    //       }
          
        
    //       return request;
    //     }
    //     getConsulta();
    //   }, []);
      const ejecutasalirModal=()=>{
        setInfoModal(false);
      }
      const ejecutasalirSuccess=()=>{
        setSuccessCancelationModal(false);
      }
      useEffect(async() => {
        //console.log("consulta domiciliacion useeffect")
        //console.log(props.consulta)
        const timer = setTimeout(deleteElementFromArr, 5000);
        return () => clearTimeout(timer);
      });
      
      const deleteElementFromArr = () => {
        
        if (listAlert.length > 0) {
          let temp = listAlert.slice();
          temp.splice(0, 1);
          setListAlert(temp);
        }
      };
    
      
      // const deleteElementFromArr = (lista) => {
      //   console.log("tarea automatica");
      //   console.log(lista);
      //   if (listAlert.length > 0) {
      //     let temp = listAlert.slice();
      //     console.log(temp);
      //     temp.splice(0, 1);
      //     setListAlert(temp);
      //   }
      // };
      const deleteAlert = (alert) => {
    
        console.log("elimina alerta");
        console.log(listAlert);
        setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
      };
      var Alerts = createReactClass({
        render: function () {
          var data = this.props.data;
          var newsTemplate;
          if (data.length > 0) {
            newsTemplate = data.map(function (item, index) {
              return (
                <div class={item.type} role="alert">
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    onClick={() => deleteAlert(item)}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <span className="alert-inner--icon mr-3">
                    <i className={item.icon} />
                  </span>{" "}
                  <span class="alert-inner--text">{item.description}</span>
                </div>
              );
            });
          }
          return <div className="toast-bottom-right">{newsTemplate}</div>;
        },
      });
    
  return (
  <div>
    <button
            style={{"margin-bottom":"24px",width:"35%"}}
            className="bg-green text-white btn btn-rounded btn-block ml-auto mr-auto"
            //  onClick={()=>{iniciocreaUsu()
            //  dispatch(cambiaruta("Inicio/Seguridad/Administrar Usuarios/Agregar Usuario"))}}
            onClick={()=>{props.cambioTab("creadomi");dispatch(cambiaruta("Inicio/Seguridad/Domiciliación/Agregar Domiciliación"))}}
          >
          
            <img src={
              require("../../assets/img/icons/Icono-Inscribir-Contacto-Blanco.png")
                .default
            }/>&nbsp;
            Agregar Domiciliación
    </button>
         
       
    <table className="mb-4">
    <tr>
            <th className="col-md-2 bg-grissantander text-white text-center font-weight-bold h5 p-1">
              Tipo de operación 
            </th>
            <th className="col-md-3 bg-grissantander text-white text-center font-weight-bold h5 p-1">
              Estado de la asociación
            </th>
            <th className="col-md-3 bg-grissantander text-white text-center font-weight-bold h5 p-1 ">
              Descripción de la asociación
            </th>
            <th className="col-md-1 bg-grissantander text-white text-center font-weight-bold h5 p-1">Acciones</th>
            {/*<th className="col-md-2 bg-primary text-white font-weight-bold h3 ">
              Hora ultimo ingreso
            </th>
            <th className="col-md-2 bg-primary text-white font-weight-bold h3 ">
              Fecha ultimo ingreso
            </th>*/}
          </tr>
          <Modal
            className="modal-dialog-centered"
            contentClassName="bg-transparent shadow-none"
            isOpen={isLoading}
          >
             
                  <div tabindex="-1" style={{ position: "relative;" ,  "z-index": "1050" ,  display : "block" , width:"100%", height: "80vh" }}>
                        <div style={{ "text-align": "center", top: "50%", position: "relative"  }}>
                            <img style={{height:"100px", }} src={require("../../assets/img/icons/LoaderIDEA.gif").default}></img>
                        </div>
                        <div class="modal-backdrop fade show"></div>
                    </div>
                
          </Modal>
          <Modal
                          className="modal-dialog-centered"
                          contentClassName=""
                          isOpen={cancelationsModal}
                          toggle={() => setCancelationsModal(!cancelationsModal)}
                        >
                          <div className="p-4">
                          <div onClick={ejecutasalir} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
                            <div class="my-modal-header">
                              <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                              <div class="header-title">
                                <h5 class="avv-title-bold">¿Quieres eliminar la domiciliación?</h5>
                                <p class="header-subtitle">La información que has ingresado hasta el momento se borrará.</p>
                              </div>
                            </div>
                            <div class="my-modal-footer pt-2">
                              <button class="btn bg-white text-green shadow" type="button" onClick={() => {setCancelationsModal(false)}}> No, volver </button>
                              <button class="my-btn btn bg-success text-white shadow" type="button" onClick={() => {eliminaDomiciliacion(itemDelete);setCancelationsModal(false)}}> SÍ, ELIMINAR </button>
                            </div>
                          </div>
                        </Modal>
                        <Modal
                          className="modal-dialog-centered"
                          contentClassName=""
                          isOpen={infoModal}
                          toggle={() => setInfoModal(!infoModal)}
                       >
                        <div className="p-4">
                          <div onClick={ejecutasalirModal} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
                            <div class="my-modal-header">
                              <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                              <div class="header-title">
                                <h5 class="avv-title-bold">Información de la Domiciliación</h5>
                              </div>
                              <div>
                            <ul
                              className
                              style={{
                                listStyle: "none",
                                padding: 0 + "px",
                                margin: 0 + "px",
                                lineHeight: 0.2 + 'px',
                                width:400 + 'px'
                              }}
                            >
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 0.8 + 'px',
                                  }}
                                >
                                  Estado:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px",fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.status == 1? "Activo":"Inactivo"}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight: 0.8+'px',
                                  }}
                                >
                                  Tipo de Operación:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px",fontSize:"12px",lineHeight: 0.8 +'px' }}>
                                  {detalleConsultaDomiciliacion.operationType == 1? "Transferencia Interna":detalleConsultaDomiciliacion.operationType == 2?"Transferencia Externa":detalleConsultaDomiciliacion.operationType == 3? "Pago Crédito":"Pago Convenio"}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Sistema de Origen:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px",fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.originSystem == 20?"Cuenta de ahorro corriente":detalleConsultaDomiciliacion.originSystem == 30?"Colocaciones":"Cuenta Externa"}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Producto de Origen:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px",fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.originProduct}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Periodicidad:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px",fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.periodicity == 1?"Única":detalleConsultaDomiciliacion.periodicity == 2?"Diaria":detalleConsultaDomiciliacion.periodicity == 3?"Semanal":detalleConsultaDomiciliacion.periodicity==4?"Mensual":"Dependiente Recaudo"}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Día de la semana:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px",fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.weekDay}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Día del mes de aplicación:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px", fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.dayMonthApliaction}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Fecha de Aplicación:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px", fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.applicationDate}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Sistema de destino:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px", fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.destinationSystem == 20?"Cuenta de ahorro corriente":detalleConsultaDomiciliacion.destinationSystem == 30?"Colocaciones":"Cuenta Externa"}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Producto de destino:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px", fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.destinationProduct}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Numero de Secuencia de Cuenta Externa:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px", fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.externalAccountSecuenceNumber}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Valor de transferencia:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px",fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.transferValue}
                                </p>
                              </li>
                              <li
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  padding: "5px 0",
                                }}
                              >
                                <p
                                  style={{
                                    fontWeight: 600,
                                    fontStyle: "normal",
                                    fontStretch: "normal",
                                    lineHeight:0.8+'px',
                                  }}
                                >
                                  Descripción de la Asociación:
                                </p>
                                <p style={{ textAlign: "right", margin: "0px 0px 15px 0px",fontSize:"12px",lineHeight:0.8+'px'}}>
                                  {detalleConsultaDomiciliacion.associationDescription}
                                </p>
                              </li>
                            </ul>
                          </div>         
                
                            </div>
                          </div>
                        </Modal>

                        <Modal
                          className="modal-dialog-centered"
                          contentClassName=""
                          isOpen={successCancelationModal}
                          toggle={() => setSuccessCancelationModal(!successCancelationModal)}
                        >
                          <div className="p-4">
                          <div onClick={ejecutasalirSuccess} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
                            <div class="my-modal-header">
                              <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                              <div class="header-title">
                                <h5 class="avv-title-bold">Eliminación Exitosa</h5>
                                <p class="header-subtitle">La información de esta domiciliación se borrará</p>
                              </div>
                            </div>
                          </div>
                        </Modal>
                        <Modal
                          className="modal-dialog-centered"
                          contentClassName=""
                          isOpen={isdomiexito}
                          //toggle={() => setResultModal(!cancelationModal)}
                        >
                          <div className="p-4">
                            <div class="my-modal-header">
                              <img
                                alt="delete-icon"
                                class="my-header-brand-img"
                                src={exitoCreacion}
                                
                              />
                              <div class="header-title">
                                <h5 class="avv-title-bold">Proceso exitoso</h5>
                                <p class="header-subtitle">
                                    {props.mensaje}
                                </p>
                              </div>
                            </div>
                            <div class="my-modal-footer pt-2">
                              <button
                                class="btn bg-green text-white"
                                type="button"
                                onClick={() => {                    
                                  setisdomiexito(false)
                                  props.limpianoti()
                                }}
                              >
                                Continuar
                              </button>
                            </div>
                          </div>
                        </Modal>

                        

            
            {consultaDomiciliacion.map((item,index)=>{
              if (consultaDomiciliacion) {
                return(
                  <tr>
                    <td className="col-md-1 text-left bg-white p-1" style={{fontSize:"12px"}}>{item.operationType}</td>
                    <td className="col-md-1 text-left bg-white p-1" style={{fontSize:"12px"}}>{item.status}</td>
                    <td className="col-md-1 text-left bg-white p-1" style={{fontSize:"12px"}}>{item.associationDescription}</td>
                      <td className="col-md-1 text-center bg-white p-1" style={{fontSize:"12px"}}>
                      <div style={{display:"flex", flexDirection:"row"}}>
                        {/* <button className="btn-icon bg-white text-primary btn" onClick={()=>{modificaUsuario(item)}} style={{fontSize:"10px",height:"25px", padding:"4px 4px 4px 4px"}}>Modificar</button>
                        <button className="btn-icon bg-white text-primary btn" onClick={()=>{pideconfirmbloqueousu(item.nameUser,item.tidUser,item.nidUser,item.uniqueIdUser)}} style={{fontSize:"10px",height:"25px", padding:"4px 4px 4px 4px"}}>Bloquear</button>
                        <button className="btn-icon bg-white text-primary btn" onClick={()=>{eliminaUsuario(item)}} style={{fontSize:"10px",height:"25px", padding:"4px 4px 4px 4px"}}>Eliminar</button> */}
                        <button className="btn-icon bg-white text-green btn" onClick={()=>{detalleDomiciliacion(item, "1")}}  style={{fontSize:"10px",height:"25px", padding:"4px 1px 4px 1px"}}>Detalle</button>
                        <button className="btn-icon bg-white text-green btn" onClick={()=>{detalleDomiciliacion(item, "2")}}   style={{fontSize:"10px",height:"25px", padding:"4px 1px 4px 1px"}}>Modificar</button>
                        <button className="btn-icon bg-white text-green btn" onClick={()=>{setCancelationsModal(true); setItemDelete(item)}} style={{fontSize:"10px",height:"25px", padding:"4px 1px 4px 1px"}}>Eliminar</button>
                      </div>
                      </td>
                      <Alerts data={listAlert}></Alerts>
                      <td style={{fontSize:"10px"}}>
                      
                      </td>
                      <td style={{fontSize:"10px"}}>
                      
                     
                        
                      </td>
                  </tr>
                );
              }else{
                return <h2>No hay registros para visualizar</h2>
              }
            }
            
            )
            }
      </table> 
      
    </div> 
    
                            
  );
}

export default ConsultaDomiciliacion